import { render, staticRenderFns } from "./EventTypesCms.vue?vue&type=template&id=c108d1f4"
import script from "./EventTypesCms.vue?vue&type=script&lang=js"
export * from "./EventTypesCms.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports